import { render, staticRenderFns } from "./html/InputPhone.html?vue&type=template&id=151f1a7f&lang=html&external"
import script from "./js/InputPhone.js?vue&type=script&lang=js&external"
export * from "./js/InputPhone.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports